import axios from "axios";
import Config from "../common/Config";
import FieldState from "../common/FieldState";
import OrderFormStep from "../common/OrderFormStep";
import FormTitle from "../components/formTitle/FormTitle";
import MuiRadio from "../components/radio/MuiRadio";
import MuiCheckbox from "../components/checkbox/MuiCheckbox";
import InputTextField from "../components/textField/InputTextField";
import MuiDatePicker from "../components/datePicker/MuiDatePicker";
import Button from "../components/button/Button";
import SecondaryButton from "../components/button/SecondaryButton";
import { CreateNotification } from "../components/notification/Notification";
import SaveAsDraft from "../components/modal/SaveAsDraft";
import "react-datepicker/dist/react-datepicker.css";
import TPEProgessiveSizeGuide from "../images/TPEProgressive.png";
import TPEUniformSizeGuide from "../images/TPEUniform.png";
import TPESymmetricalSizeGuide from "../images/TPESymmetrical.png";
import SiliconeProgressiveSizeGuide from "../images/SiliconeProgressive.png";
import SiliconeSymmetricalSizeGuide from "../images/SiliconeSymmetrical.png";
import SiliconeUniformSizeGuide from "../images/SiliconeUniform.png";
import TruSealConicalSizeGuide from "../images/TruSealConical.png";
import TruSealCylindricalSizeGuide from "../images/TruSealCylindrical.png";
import { Col, Container, Row, Table } from "react-bootstrap";
import TextField from '@material-ui/core/TextField';
import ClearOrder from "../components/modal/ClearOrder";

import {
  Alert,
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
} from "@mui/material";

export default class KneeBundleLinerSelection extends OrderFormStep {
  constructor(props) {
    super(props);


    this.state = {
      isSubmit: false,
      linerInterfaces: [],
      linerSizes: [],
      linerProfiles: [],
      linerOptionCombinations: [],
      linerSuspensions: [],
      formState: {
        currentLiners: [],
        linerPartNumber: new FieldState(false, ""),
        linerSuspension: new FieldState(false),
        linerInterface: new FieldState(false),
        linerSize: new FieldState(false),
        linerProfile: new FieldState(false),
        linerQuantity: new FieldState(false, 1),
        selectedLinerPartNumber: null,
      },
    };

    this.addLinerFromPartNumber = this.addLinerFromPartNumber.bind(this);
    this.addLinerFromSelection = this.addLinerFromSelection.bind(this);
    this.loadCart = this.loadCart.bind(this);
  }

  getSuspensionText(suspensionId) {
    return this.state.linerSuspensions.filter(c => c.id === suspensionId)[0]?.displayName;
  }

  setServerLinerQuantity(partNumber, quantity) {
    let config = {};
    config.headers = {
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("token")).access_token,
    };

    axios.post(
      Config.baseApiUrl + "linerQuantity/" + this.props.formTypeId,
      {
        partnumber: partNumber,
        quantity: quantity
      },
      config
    ).then(response => {
      if(response.data.success) {
        this.loadCart();
      } else {
        CreateNotification(response.data.message, "error");
      }
    });
  }

  setLocalLinerQuantity(partNumber, quantity) {
    var formState = this.state.formState
    var liners = formState.currentLiners;
    liners = this.state.formState.currentLiners.map((liner) => {
      if (liner.partNumber === partNumber) {
        liner.quantity = quantity;
      }

      return liner;
    });

    formState.currentLiners = liners;
    this.setState({
      formState: formState
    });
  }

  addLinerFromPartNumber() {
    var formState = this.state.formState;

    let partNumber = formState.linerPartNumber.value;
    let quantity = formState.linerQuantity.value;

    this.addLinerRequest(partNumber, quantity);

    formState.linerPartNumber.value = "";
    formState.linerQuantity.value = 1;

    this.setState({
      formState: formState
    });
  }

  addLinerFromSelection() {

    var formState = this.state.formState;

    let partNumber = formState.selectedLinerPartNumber;
    let quantity = formState.linerQuantity.value;

    this.addLinerRequest(partNumber, quantity);


    formState.linerQuantity.value = 1;
    formState.selectedLinerPartNumber = null;

    this.setState({
      formState: formState
    });
  }

  addLinerRequest(partNumber, quantity) {
    let config = {};
    config.headers = {
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("token")).access_token,
    };

    axios.post(
      Config.baseApiUrl + "addLiner/" + this.props.formTypeId,
      {
        partnumber: partNumber,
        quantity: quantity
      },
      config
    ).then(response => {
      if(response.data.success) {
        if(response.data.leadTimeDays >= 10) {
          CreateNotification("This liner has a lead time of up to " + response.data.leadTimeDays
              + " days. If you need this liner sooner, please consult WillowWood Customer Care at 1-800-848-4930."
              , "warning"
              , "top-right"
              , false
              , true
              , true
              , false)
        }
        this.loadCart();
      } else {
        CreateNotification(response.data.message, "error");
      }
    });
  }


  async loadCart() {
    let config = {};
    config.headers = {
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("token")).access_token,
    };
    var saveLiners = (cartData) => {
      let liners = cartData.map((item) => {
        if (item === null) {
          return null;
        }

        return {
          name: item.name,
          partNumber: item.partNumber,
          quantity: item.quantity
        };
      });

      var formState = this.state.formState;
      formState.currentLiners = liners;
      this.setState({
        formState: formState
      });
    }
    saveLiners=saveLiners.bind(this);

    await axios.get(
      Config.baseApiUrl + "cart/" + this.props.formTypeId,
      config
    ).then(response => {
      this.props.setTempCart(response.data);
      saveLiners(response.data);
      this.props.loadCart();
    }).catch(error => {
      console.log(error)
    });

    let currentSuspension = this.getSuspensionText(this.state.formState.linerSuspension.value);
    let currentInterface = this.state.formState.linerInterface.value;
    let currentProfile = this.state.formState.linerProfile.value;
    let currentSize = this.state.formState.linerSize.value;

    let partnumber = this.state.linerOptionCombinations.filter(
      c => c.interfaceId === currentInterface 
      && c.profileId === currentProfile 
      && c.sizeId === currentSize
      && c.suspension === currentSuspension
    )[0]?.partNumber;

    var formState = this.state.formState;
    formState.selectedLinerPartNumber = partnumber;

    this.setState({ formState: formState, hasDataChanged: true });

  }

  isRequired() {
    return false;
  }

  updateRequirements() {
    var formState = this.state.formState;
    var required = this.isRequired();

    formState.linerInterface.isRequired = required;
    formState.linerSize.isRequired = required;
    formState.linerProfile.isRequired = required;
    formState.linerQuantity.isRequired = required;

    this.setState({
      formState: formState
    });
  }

  onInputChange(e, id) {
    let formState = this.state.formState;
    formState.linerQuantity.value = e.target.value;
    this.setState({
      formState: formState,
      hasDataChanged: true,
    });
  }

  componentDidMount() {
    this.loadData();
  }

  async loadData() {
      this.setState({
        linerSuspensions: (
          await axios.get(
            Config.baseApiUrl + "fieldOptions/" + this.props.formTypeId,
            {
              params: { fieldName: "linerSuspension" },
            }
          )
        ).data,
        linerInterfaces: (
          await axios.get(
            Config.baseApiUrl + "fieldOptions/" + this.props.formTypeId,
            {
              params: { fieldName: "linerInterface" },
            }
          )
        ).data,
        linerSizes: (
          await axios.get(
            Config.baseApiUrl + "fieldOptions/" + this.props.formTypeId,
            {
              params: { fieldName: "linerSize" },
            }
          )
        ).data,
        linerProfiles: (
          await axios.get(
            Config.baseApiUrl + "fieldOptions/" + this.props.formTypeId,
            {
              params: { fieldName: "linerProfile" },
            }
          )
        ).data,
      });

      this.setState({
        linerOptionCombinations: (
          await axios.get(
            Config.baseApiUrl + "liners/" + this.props.formTypeId,
            {
              headers: {
                Authorization:
                  "Bearer " + JSON.parse(localStorage.getItem("token")).access_token,
              }
            }
          )
        ).data
      });
    
    await this.loadCart();
    this.setState({ isLoaded: true });
  }

  saveData() {
    let totalNoOfLiners = 0;
    if (this.state.formState.currentLiners !== null) {
      this.state.formState.currentLiners.forEach(cl => {
        totalNoOfLiners += parseInt(cl.quantity);
      })
    }
    
    if (totalNoOfLiners === 0) {
      CreateNotification("Cannot place Liner Order with no items.", "error");
      return null;
    }

    let config = {};
    config.headers = {
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("token")).access_token,
    };

    let data = [];

    return axios.post(
      Config.baseApiUrl + "fieldInputs/" + this.props.formTypeId,
      data,
      config
    );
  }

  handleError(id) {
    const { formState } = this.state;
    const errorClass =
      formState[id].isRequired &&
      (formState[id].value === "" ||
        formState[id].value === 0 ||
        formState[id].value === null);
    return errorClass ? true : false;
  }

  render() {
    if (!this.state.isLoaded) return this.makeLoadingText();

    let validSuspensions = this.state.linerSuspensions;
    let currentSuspension = this.getSuspensionText(this.state.formState.linerSuspension.value);

    let validProfiles = this.state.linerProfiles.filter(p =>
      this.state.linerOptionCombinations.some(c => c.profileId === p.id 
                                                && c.suspension === currentSuspension)
    );
    let currentProfile = this.state.formState.linerProfile.value;

    let validInterfaces = this.state.linerInterfaces.filter(i => 
      this.state.linerOptionCombinations.some(c => c.interfaceId === i.id 
                                                && c.suspension === currentSuspension
                                                && c.profileId === currentProfile)
    );
    let currentInterface = this.state.formState.linerInterface.value;

    let validSizes = this.state.linerSizes.filter(s =>
      this.state.linerOptionCombinations.some(c => c.interfaceId === currentInterface 
                                                && c.profileId === currentProfile 
                                                && c.sizeId === s.id
                                                && c.suspension === currentSuspension)
    );
    let validCylindricalSizes = this.state.linerSizes.filter(s =>
      this.state.linerOptionCombinations.some(c => c.interfaceId === currentInterface 
                                                && c.profileId === currentProfile 
                                                && c.sizeId === s.id
                                                && c.suspension === currentSuspension
                                                && c.sizeGuide==="TruSealCylindrical")
    );
    let validConicalSizes = this.state.linerSizes.filter(s =>
      this.state.linerOptionCombinations.some(c => c.interfaceId === currentInterface 
                                                && c.profileId === currentProfile 
                                                && c.sizeId === s.id
                                                && c.suspension === currentSuspension
                                                && c.sizeGuide==="TruSealConical")
    );
    let currentSize = this.state.formState.linerSize.value;

    let hasBothCs = validConicalSizes.length > 0 && validCylindricalSizes.length > 0;

    let combos = this.state.linerOptionCombinations.filter(
      c => c.interfaceId === currentInterface 
      && c.profileId === currentProfile
      && c.suspension === currentSuspension
    );
    let sizeGuide = combos[0]?.sizeGuide;
    let partnumber = combos.filter(c => c.sizeId === currentSize)[0]?.partNumber;

    let image = null;
    switch(sizeGuide) {
      case "TPEProgressive" : image = TPEProgessiveSizeGuide;
        break;
      case "TPEUniform" : image = TPEUniformSizeGuide;
        break;
      case "TPESymmetrical" : image = TPESymmetricalSizeGuide;
        break;
      case "SiliconeProgressive" : image = SiliconeProgressiveSizeGuide;
        break;
      case "SiliconeSymmetrical" : image = SiliconeSymmetricalSizeGuide;
        break;
      case "SiliconeUniform" : image = SiliconeUniformSizeGuide;
        break;
      case "TruSealCylindrical" : image = TruSealCylindricalSizeGuide;
        break;
      case "TruSealConical" : image = TruSealConicalSizeGuide;
        break;
      //TODO rest of images
      default: image = null;
    }

    return (
      <>
        <div className="checkFormWrapper">
          <FormTitle
            title="Product Information"
            description=""
          />

          <form className="checkform" onSubmit={e => { e.preventDefault() }}>

            <div className="fieldBorder">
              <div className="msgBox fieldBorder msgBoxWidth">
                <h4 className="headLable"><b>Quick Entry</b></h4>
                <br />
                <p><a target="_blank" href="https://willowwood.com/product-category/products/liners/">Click here to find your Alpha Liner Part Number</a></p>
                <p>Use this section to add a liner to your order if you already know the part number. Enter the Part Number below, update Quantity desired and “Add” to Cart.</p>
                <p className="font-italic text-secondary">Example Part Number H352-6394.</p>
              </div>
              <div className="fieldWrapper" style={{ paddingTop: '10px' }}>
                <InputTextField
                  label="Part Number"
                  variant="outlined"
                  placeholder=""
                  type="text"
                  width="384px"
                  required={false}
                  value={this.state.formState.linerPartNumber.value}
                  onChange={(e) => {
                    let formstate = this.state.formState;
                    formstate.linerPartNumber.value = e.target.value.toUpperCase();
                    this.setState({ formState: formstate });
                  }}
                />
                <InputTextField
                  label="Liner Quantity"
                  variant="outlined"
                  placeholder=""
                  type="number"
                  width="384px"
                  required={false}
                  value={this.state.formState.linerQuantity.value}
                  onChange={this.onInputChange}
                />
                <div style={{ paddingTop: '20px' }}>
                  <SecondaryButton
                    text="Add"
                    onClick={this.addLinerFromPartNumber}
                  />
                </div>
              </div>
            </div>

            <br />

            <div className="msgBox fieldBorder msgBoxWidth">
            <h4 className="headLable"><b>Liner Part Number Wizard</b></h4>
            <br />
            <p>Only the following liners are included in the Liner Part Number Wizard:</p> 
            <ul>
              <li>ALPHA Classic MP</li>
              <li>ALPHA Hybrid</li>
              <li>ALPHA Silicone</li>
              <li>ALPHA TruSeal</li>
              <li>ALPHA SmartTemp Silicone</li>
              <li>ALPHA SmartTemp TPE</li>
            </ul>
            <p className="red-emphasis">All other liners need to be ordered by SKU via Quick Entry above.</p>
          </div>
              <div className="fieldBorder">
                <MuiRadio
                  options={validSuspensions}
                  defaultValue={this.state.formState.linerSuspension.value}
                  label="Suspension"
                  required={this.state.formState["linerSuspension"].isRequired}
                  error={this.handleError("linerSuspension") && this.state.isSubmit}
                  checked
                  onChange={(e) => {
                    this.onRadioChange(e, "linerSuspension");
                  }}
                />
              </div>

              <div className="fieldBorder">
                <MuiRadio
                  options={validProfiles}
                  defaultValue={currentProfile}
                  label="Profile"
                  required={this.state.formState["linerProfile"].isRequired}
                  error={this.handleError("linerProfile") && this.state.isSubmit}
                  checked
                  onChange={(e) => {
                    this.onRadioChange(e, "linerProfile");
                  }}
                />
              </div>

              <div className="fieldBorder">
                <MuiRadio
                  options={validInterfaces}
                  defaultValue={currentInterface}
                  label="Interface"
                  required={this.state.formState["linerInterface"].isRequired}
                  error={this.handleError("linerInterface") && this.state.isSubmit}
                  checked
                  onChange={(e) => {
                    this.onRadioChange(e, "linerInterface");
                  }}
                />
              </div>

              {!hasBothCs &&
                <div className="fieldBorder">
                  <MuiRadio
                    options={validSizes}
                    defaultValue={currentSize}
                    label="Size"
                    required={this.state.formState["linerSize"].isRequired}
                    error={this.handleError("linerSize") && this.state.isSubmit}
                    checked
                    onChange={(e) => {
                      this.onRadioChange(e, "linerSize");
                    }}
                  />
                  {image && <img src={image} width="800" alt="Size Guide" />}
                </div>
              }

              {hasBothCs &&
                <div className="fieldBorder">
                  <div className="radioGroup">
                    <FormControl>
                      <RadioGroup
                        aria-labelledby="demo-radio-buttons-group-label"
                        value={currentSize}
                        defaultValue={currentSize}
                        onChange={(e) => {
                          this.onRadioChange(e, "linerSize");
                        }}
                        name="radio-buttons-group"
                        row
                      >
                        <FormLabel id="demo-radio-buttons-group-label">
                            Size
                            {this.state.formState["linerSize"].isRequired ? (
                              <span style={{ color: "red" }}>*</span>
                            ) : (
                              ""
                            )}
                          </FormLabel>
                        <div style={{ display: "flex", flexDirection: "column" }}>
                          <FormLabel id="demo-radio-buttons-group-label">
                            Conical
                          </FormLabel>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              flexWrap: "wrap",
                              gap: "16px",
                            }}
                          >
                            {validConicalSizes
                              .map((size) => (
                                <FormControlLabel
                                  value={size.id}
                                  control={<Radio />}
                                  label={
                                    <div className="radioLabel">
                                      <div className="radioIcon">
                                        <span>{size.displayName}</span>
                                      </div>
                                    </div>
                                  }
                                  className={`${
                                    parseInt(this.selectedValue) === size.id || currentSize === size.id
                                      ? "checkedLabel"
                                      : ""
                                  }`}
                                />
                              ))}
                          </div>
                        </div>
                        <img src={TruSealConicalSizeGuide} width="800" alt="Size Guide" />

                        <br />

                        <div style={{ display: "flex", flexDirection: "column" }}>
                          <FormLabel id="demo-radio-buttons-group-label">
                            Cylindrical
                          </FormLabel>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              flexWrap: "wrap",
                              gap: "16px",
                            }}
                          >
                            {validCylindricalSizes
                              .map((size) => (
                                <FormControlLabel
                                  value={size.id}
                                  control={<Radio />}
                                  label={
                                    <div className="radioLabel">
                                      <div className="radioIcon">
                                        <span>{size.displayName}</span>
                                      </div>
                                    </div>
                                  }
                                  className={`${
                                    parseInt(this.selectedValue) === size.id || currentSize === size.id
                                      ? "checkedLabel"
                                      : ""
                                  }`}
                                />
                              ))}
                          </div>
                        </div>
                        <img src={TruSealCylindricalSizeGuide} width="800" alt="Size Guide" />
                      </RadioGroup>
                    </FormControl>
                  </div>
                </div>
              }

              <div className="fieldWrapper" style={{ paddingTop: '10px'}}>
                  <InputTextField
                    label="Selected Part Number"
                    variant="outlined"
                    placeholder=""
                    type="text"
                    width="384px"
                    required={false}
                    disabled
                    value={partnumber}
                    
                  />
                  <InputTextField
                    label="Liner Quantity"
                    variant="outlined"
                    placeholder=""
                    type="number"
                    width="384px"
                    required={false}
                    value={this.state.formState.linerQuantity.value}
                    onChange={this.onInputChange}
                  />
                  <div style={{ paddingTop: '20px'}}>
                  <SecondaryButton
                    text="Add"
                    onClick={this.addLinerFromSelection}
                  />
                  </div>
              </div>
              {this.state.formState.currentLiners.length > 0 && 
                <div className="fieldBorder">
                  <br />
                  <div className="msgBox fieldBorder msgBoxWidth">
                    <h4 className="headLable"><b>Current Liners in Cart</b></h4>
                  </div>
                  <br />
                  <Table className="transparent-table">
                  <thead>
                    <tr>
                      <th><b>Liner</b></th>
                      <th></th>
                      <th><b>Part Number</b></th>
                      <th><b>Quantity</b></th>
                      <th></th>
                    </tr>
                  </thead>  
                    <tbody>  
                      {this.state.formState.currentLiners.map((liner) => {
                          if(liner === null) {
                            return "";
                          }

                        return (
                          <tr key={liner.partNumber}>
                            <td lg="6" sm="1">
                              <div>{liner.name}</div>
                            </td>
                            <td></td>
                            <td>
                              <div>{liner.partNumber}</div>
                            </td>
                            <td>
                              <TextField
                                type={"number"}
                                onChange={(e) => this.setLocalLinerQuantity(liner.partNumber, e.target.value)}
                                onBlur={() => this.setServerLinerQuantity(liner.partNumber, liner.quantity)}
                                value={liner.quantity}
                              />
                            </td>
                            <td><SecondaryButton
                              text="Remove"
                              onClick={() => this.setServerLinerQuantity(liner.partNumber, 0)}
                            />
                            </td>
                          </tr>
                        )
                      })}
                    </tbody>
                  </Table>
                </div>
              }
          </form>
        </div>

        <div className="handelButtons">
          <SecondaryButton
            text="Save As Draft"
            onClick={this.props.handleClickOpen}
          />
          <SecondaryButton
            text="Clear the Order?"
            onClick={this.props.handleClickClearOpen}
          />
          <div className="stepBtn">
            <SecondaryButton
              text="Back"
              onClick={() => this.props.handleBack(this.props.currentIndex - 1)}
              disabled={
                this.props.activeOuterStep === 0 && this.props.innerStep === 0
              }
            />
            <Button
              text="Next"
              disabled={this.state.isLoading}
              onClick={async () => {
                try {
                  this.setState({ isLoading: true });
                  const res = await this.saveData();
                  if (res.status === 204) {
                    this.props.handleNext(3);
                    this.setState({ isLoading: false });
                  }
                } catch (err) {
                  this.setState({ isLoading: false });
                }
              }}
            />
          </div>
        </div>
        <SaveAsDraft
          open={this.props.open}
          handleClose={this.props.handleClose}
          showSubmit={this.props.showSubmit}
          setShowSubmit={this.props.setShowSubmit}
        />
        <ClearOrder
          openClear={this.props.openClear}
          handleCloseClear={this.props.handleCloseClear}
          showClear={this.props.showClear}
          setShowClear={this.props.setShowClear}
          formId={this.props.formTypeId}
          handleClearBack={this.props.handleClearBack}
        />
      </>
    );
  }
}
